import { FilesDropzone } from './files-dropzone.js';

FilesDropzone.defineCustomElement();

export { FilesDropzone };
